import { defineComponent, ref, watch, onMounted, computed } from 'vue';
// import HetaoLogo from '@/assets/image/home/logo3.png';
import HetaoLogoWithoutBrand from '@/assets/image/home/logo5.png';
import HetaoLogoNoc from '@/assets/image/home/logo_noc.png';
import { EnvironmentOutlined } from '@ant-design/icons-vue';
// import { environment } from '@/utils/environment';
import { useRouter, useRoute } from 'vue-router';
import { LoginService } from '@/services/login.service';
import { UserService } from '@/services/user.service';
import { useService } from '@kaokei/use-vue-service';
import LoginDialog from './LoginDialog.vue';
import GoToEnvCheckDialog from './GoToEnvCheckDialog.vue';
import GetLoginAccountDialog from './GetLoginAccountDialog.vue';
import GetAccountInfoDialog from './GetAccountInfoDialog.vue';
import { SHOW_BRAND, StoreLoginUrlName, domains } from '@/utils';
export default defineComponent({
  name: 'HomeHeader',
  components: {
    LoginDialog: LoginDialog,
    GoToEnvCheckDialog: GoToEnvCheckDialog,
    EnvironmentOutlined: EnvironmentOutlined,
    GetLoginAccountDialog: GetLoginAccountDialog,
    GetAccountInfoDialog: GetAccountInfoDialog
  },
  setup: function () {
    var selectedKeys = ref([]);
    var showCloseBtn = ref(true);
    var route = useRoute();
    setKeys(route);
    var router = useRouter();
    router.afterEach(function (to) {
      setKeys(to);
    });
    var isHideInfo = Boolean(route.query.from);
    var clickMenuItem = function (e) {
      var key2 = e.key;
      selectedKeys.value = [key2];
      router.push(key2);
    };
    function setKeys(to) {
      var path = to.path;
      // openKeys.value.push(path.slice(0, path.indexOf('/', 1)));
      selectedKeys.value = [path];
    }
    var userService = useService(UserService);
    var loginService = useService(LoginService);
    var getUrlData = function (url) {
      var urlParse = new URL(url);
      var params = {};
      urlParse.searchParams.forEach(function (value, key) {
        params[key] = value;
      });
      return {
        pathname: urlParse.pathname,
        params: params
      };
    };
    var logout = function () {
      var _a, _b;
      var storeLoginUrl = window.localStorage.getItem(StoreLoginUrlName);
      if (storeLoginUrl) {
        var urlData = getUrlData(storeLoginUrl);
        userService.logout();
        router.replace({
          path: urlData.pathname,
          query: urlData.params
        });
        return;
      }
      userService.logout();
      if ((_a = route.meta) === null || _a === void 0 ? void 0 : _a.logoutPath) {
        var newQuery = ((_b = route.meta) === null || _b === void 0 ? void 0 : _b.ignoreQuery) ? {} : route.query;
        router.replace({
          path: route.meta.logoutPath,
          query: newQuery
        });
      }
    };
    var goToUserCenter = function () {
      var _a;
      var newQuery = ((_a = route.meta) === null || _a === void 0 ? void 0 : _a.ignoreQuery) ? undefined : route.query;
      router.push({
        name: 'UserItemList',
        query: newQuery
      });
    };
    watch(function () {
      return userService.user;
    }, function (user) {
      enterValidate();
      if (!(user && user.userId)) {
        if (route.meta && route.meta.auth) {
          var storeLoginUrl = window.localStorage.getItem(StoreLoginUrlName);
          if (storeLoginUrl) {
            var urlData = getUrlData(storeLoginUrl);
            router.replace({
              path: urlData.pathname,
              query: urlData.params
            });
            return;
          }
          router.replace({
            name: 'Home'
          });
        }
      }
    });
    /**
     * ============================================
     * 需求：https://project.feishu.cn/ht-poject/story/detail/14341910
     * 需要根据活动id展示不同的HomeHeader，活动结束之后可删除
     */
    // const specialActiveList: any =
    //   environment === 'production' ? [855] : [209, 210];
    watch(function () {
      return route.name;
    }, function () {
      // let currentItemId = '';
      // if (visible === 'ItemDetail') {
      //   setTimeout(() => {
      //     const currentItemId = route.params.id as string;
      //     if (
      //       specialActiveList.includes(+currentItemId) &&
      //       !userService.user
      //     ) {
      //       loginService.showLoginDialog();
      //       showCloseBtn.value = false;
      //     }
      //   }, 500);
      // }
    }, {
      immediate: true
    });
    // ============================================
    var enterValidate = function () {
      if (!route.query.showLoginModal) return;
      if (!(userService.user && userService.user.userId)) {
        loginService.showLoginDialog();
        showCloseBtn.value = false;
      } else {
        loginService.hideLoginDialog();
      }
    };
    onMounted(function () {
      enterValidate();
    });
    var isNocFlag = computed(function () {
      return route.query.platform === 'noc';
    });
    // 解决合肥投诉品牌事件 2024-03-21
    // const HetaoLogoFinal = SHOW_BRAND ? HetaoLogo : HetaoLogoWithoutBrand;
    var HetaoLogoFinal = isNocFlag.value ? HetaoLogoNoc : HetaoLogoWithoutBrand;
    var times = 0;
    var clearStorageLoginUrl = function () {
      if (times++ === 6) {
        window.localStorage.removeItem(StoreLoginUrlName);
        times = 0;
      }
    };
    var showLoginDialog = function () {
      loginService.showLoginDialog();
    };
    return {
      HetaoLogoFinal: HetaoLogoFinal,
      selectedKeys: selectedKeys,
      clickMenuItem: clickMenuItem,
      loginService: loginService,
      userService: userService,
      logout: logout,
      goToUserCenter: goToUserCenter,
      SHOW_BRAND: SHOW_BRAND,
      domains: domains,
      showCloseBtn: showCloseBtn,
      isNocFlag: isNocFlag,
      isHideInfo: isHideInfo,
      clearStorageLoginUrl: clearStorageLoginUrl,
      showLoginDialog: showLoginDialog
    };
  }
});